import { Box, Stack, TextField } from '@mui/material';

import type { Weekday } from '../../../../../../../../components/WeekDaysSelector/WeekDaysSelector';

export interface TimeRangeValue {
  start: { hours: number; minutes: number };
  end: { hours: number; minutes: number };
}

export enum OutsideWindowBehavior {
  Skip = 'Skip',
  Queue = 'Queue',
}

export interface CommunicationWindow {
  daysOfWeek?: Weekday[];
  timeRange?: TimeRangeValue;
  timeZone?: string;
  outsideWindowBehavior?: OutsideWindowBehavior;
}

interface TimeRangeProps {
  times?: CommunicationWindow;
  disabled?: boolean;
  onTimeRangeChange: (timeRange: TimeRangeValue) => void;
}

export function CommunicationWindowTimeRange(props: TimeRangeProps) {
  const { times, disabled, onTimeRangeChange } = props;
  const timeRange = times?.timeRange;
  const startTime = timeRange?.start ?? { hours: 0, minutes: 0 };
  const endTime = timeRange?.end ?? { hours: 23, minutes: 59 };

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <TextField
        type="time"
        value={`${String(startTime.hours).padStart(2, '0')}:${String(startTime.minutes).padStart(2, '0')}`}
        onChange={(event) => {
          const [hours, minutes] = event.target.value.split(':').map(Number);
          const newStartTime = { hours: hours || 0, minutes: minutes || 0 };
          onTimeRangeChange({
            start: newStartTime,
            end: endTime,
          });
        }}
        disabled={disabled}
        size="small"
        sx={{ minWidth: 120 }}
      />

      <Box>to</Box>

      <TextField
        type="time"
        value={`${String(endTime.hours).padStart(2, '0')}:${String(endTime.minutes).padStart(2, '0')}`}
        onChange={(event) => {
          const [hours, minutes] = event.target.value.split(':').map(Number);
          const newEndTime = { hours: hours || 0, minutes: minutes || 0 };
          onTimeRangeChange({
            start: startTime,
            end: newEndTime,
          });
        }}
        disabled={disabled}
        size="small"
        sx={{ minWidth: 120 }}
      />
    </Stack>
  );
}
